/* Kiddil — theme interactions (shell v2)
   Developed by Mohamed Shaheen · work.mshaheen@gmail.com · © 2026 Kiddil LLC */
(function () {
  "use strict";

  var header = document.getElementById("siteHeader");

  /* ---------- Sticky header shadow ---------- */
  function onScroll() {
    header.classList.toggle("is-stuck", window.scrollY > 8);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- Mega menus ---------- */
  var menuItems = Array.prototype.slice.call(document.querySelectorAll(".nav-item[data-menu]"));
  var closeTimer = null;
  function closeMenus(except) {
    menuItems.forEach(function (item) {
      if (item !== except) {
        item.classList.remove("is-open");
        var b = item.querySelector(".nav-item__title");
        if (b) b.setAttribute("aria-expanded", "false");
      }
    });
    header.classList.toggle("has-open-menu", !!except);
  }
  menuItems.forEach(function (item) {
    var btn = item.querySelector(".nav-item__title");
    function open() {
      clearTimeout(closeTimer);
      closeMenus(item);
      item.classList.add("is-open");
      btn.setAttribute("aria-expanded", "true");
      header.classList.add("has-open-menu");
    }
    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { closeMenus(null); }, 180);
    }
    item.addEventListener("mouseenter", open);
    item.addEventListener("mouseleave", scheduleClose);
    btn.addEventListener("click", function () {
      item.classList.contains("is-open") ? closeMenus(null) : open();
    });
  });

  /* ---------- Header search morph ---------- */
  var searchBtn = document.querySelector(".site-header__action--search");
  var searchClose = document.querySelector(".site-header__search-close");
  var searchInput = document.getElementById("searchInput");
  function openSearch() {
    closeMenus(null);
    header.classList.add("is-search-visible");
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 50);
  }
  function closeSearch() { header.classList.remove("is-search-visible"); }
  if (searchBtn) searchBtn.addEventListener("click", function () {
    header.classList.contains("is-search-visible") ? closeSearch() : openSearch();
  });
  if (searchClose) searchClose.addEventListener("click", closeSearch);

  /* ---------- Hero slider ---------- */
  var slides = Array.prototype.slice.call(document.querySelectorAll(".hero__slide"));
  var dots = Array.prototype.slice.call(document.querySelectorAll(".hero__dot"));
  var current = 0, timer = null;
  var noAuto = /noautoplay/.test(location.search);
  function goTo(i) {
    current = (i + slides.length) % slides.length;
    slides.forEach(function (s, k) {
      var on = k === current;
      s.classList.toggle("is-active", on);
      // The panel state has to move with the class, or the accessibility tree
      // keeps describing the first slide as the visible one forever.
      if (on) s.removeAttribute("aria-hidden"); else s.setAttribute("aria-hidden", "true");
    });
    dots.forEach(function (d, k) {
      var on = k === current;
      d.classList.toggle("is-active", on);
      d.setAttribute("aria-selected", on ? "true" : "false");
      d.tabIndex = on ? 0 : -1;
    });
  }
  function play() {
    clearInterval(timer);
    if (noAuto || !slides.length) return;
    timer = setInterval(function () { goTo(current + 1); }, 6000);
  }
  dots.forEach(function (d, k) {
    d.addEventListener("click", function () { goTo(k); play(); });
    // Arrow keys are what a tablist is expected to answer to.
    d.addEventListener("keydown", function (e) {
      var step = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
      if (!step) return;
      e.preventDefault();
      var rtl = document.documentElement.dir === "rtl";
      goTo(current + (rtl ? -step : step));
      play();
      if (dots[current]) dots[current].focus();
    });
  });
  play();
  var track = document.getElementById("heroTrack");
  if (track) {
    var startX = null;
    track.addEventListener("touchstart", function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener("touchend", function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { goTo(current + (dx < 0 ? 1 : -1)); play(); }
      startX = null;
    }, { passive: true });
  }

  /* ---------- Generic sliders: snap-safe arrows + drag ---------- */
  Array.prototype.slice.call(document.querySelectorAll("[data-slider]")).forEach(function (slider) {
    var viewport = slider.querySelector(".slider__viewport");
    if (!viewport) return;
    var row = viewport.querySelector(".slider__row") || viewport;
    var next = slider.querySelector(".slider__arrow--next");
    var prev = slider.querySelector(".slider__arrow--prev");
    if (!prev) {
      prev = document.createElement("button");
      prev.className = "slider__arrow slider__arrow--prev";
      prev.setAttribute("aria-label", "Previous");
      prev.innerHTML = '<svg style="transform:rotate(180deg)"><use href="#i-arrow-r"/></svg>';
      prev.hidden = true;
      slider.appendChild(prev);
    }
    function cardStep() {
      var kids = row.children;
      if (kids.length > 1) return kids[1].offsetLeft - kids[0].offsetLeft;
      return Math.round(viewport.clientWidth * 0.8);
    }
    function page(dir) {
      var step = cardStep();
      var per = Math.max(1, Math.floor(viewport.clientWidth / step));
      var target = viewport.scrollLeft + dir * per * step;
      target = Math.round(target / step) * step;
      viewport.scrollTo({ left: target, behavior: "smooth" });
    }
    function sync() {
      var max = viewport.scrollWidth - viewport.clientWidth - 4;
      var flat = viewport.scrollWidth <= viewport.clientWidth + 4;
      if (next) next.hidden = flat || viewport.scrollLeft >= max;
      prev.hidden = flat || viewport.scrollLeft <= 4;
    }
    if (next) next.addEventListener("click", function (e) { e.preventDefault(); page(1); });
    prev.addEventListener("click", function (e) { e.preventDefault(); page(-1); });
    viewport.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();

    /* mouse drag-to-scroll (touch scrolls natively) */
    var dragging = false, dragMoved = 0, dragX = 0, dragSL = 0;
    viewport.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse" || e.button !== 0) return;
      dragging = true; dragMoved = 0; dragX = e.clientX; dragSL = viewport.scrollLeft;
    });
    window.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      var dx = e.clientX - dragX;
      if (Math.abs(dx) > 4) {
        viewport.classList.add("is-drag");
        dragMoved = Math.max(dragMoved, Math.abs(dx));
        viewport.scrollLeft = dragSL - dx;
      }
    });
    window.addEventListener("pointerup", function () {
      if (!dragging) return;
      dragging = false;
      if (dragMoved > 6) {
        var step = cardStep();
        var target = Math.round(viewport.scrollLeft / step) * step;
        viewport.classList.remove("is-drag");
        viewport.scrollTo({ left: target, behavior: "smooth" });
      } else {
        viewport.classList.remove("is-drag");
      }
    });
    viewport.addEventListener("click", function (e) {
      if (dragMoved > 6) { e.preventDefault(); e.stopPropagation(); dragMoved = 0; }
    }, true);
  });

  /* ---------- Mobile drawer (side) ---------- */
  var burger = document.querySelector(".site-header__burger");
  var mdrawer = document.getElementById("mobileDrawer");
  if (burger && mdrawer) {
    burger.addEventListener("click", function () {
      if (mdrawer.classList.contains("is-open")) { closeDrawers(); }
      else { closeMenus(null); closeSearch(); openDrawer(mdrawer); }
    });
  }

  /* ---------- Scrim + side drawers ---------- */
  var scrim = document.getElementById("scrim");
  var cartDrawer = document.getElementById("cartDrawer");
  var filterDrawer = document.getElementById("filterDrawer");
  function closeDrawers() {
    [cartDrawer, filterDrawer, document.getElementById("mobileDrawer")].forEach(function (d) { if (d) d.classList.remove("is-open"); });
    if (scrim) scrim.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  function openDrawer(d) {
    if (!d) return;
    closeDrawers();
    d.classList.add("is-open");
    if (scrim) scrim.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  if (scrim) scrim.addEventListener("click", closeDrawers);
  Array.prototype.slice.call(document.querySelectorAll("[data-close-drawers]")).forEach(function (b) {
    b.addEventListener("click", closeDrawers);
  });
  var filterPill = document.querySelector(".filter-pill");
  if (filterPill) filterPill.addEventListener("click", function () { openDrawer(filterDrawer); });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeMenus(null); closeSearch(); closeDrawers(); }
  });

  /* ---------- Cart (Shopify AJAX) ---------- */
  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    (/^ar(?:-|$)/i.test(document.documentElement.lang) && /^\/ar(?:\/|$)/.test(location.pathname) ? "/ar/" : "/");
  cartRoot = cartRoot.replace(/\/?$/, "/");
  var FREE_SHIP = (window.KIDDIL && window.KIDDIL.freeShip) || 99900;
  var I = (window.KIDDIL && window.KIDDIL.i18n) || {};
  // The currency word sits before the number in English and after it in Arabic,
  // so the pattern comes from the locale file rather than being built here.
  function money(v) { return (I.money || "EGP __AMT__").replace("__AMT__", v); }
  function fmt(cents) { return money(Math.round(cents / 100).toLocaleString("en-EG")); }
  function updateBadge(count) {
    var badge = document.getElementById("cartCount");
    if (badge) { badge.textContent = count; badge.classList.toggle("has", count > 0); }
  }
  function renderCartData(cart) {
    updateBadge(cart.item_count);
    var wrap = document.getElementById("cartItems");
    if (!wrap) return;
    var empty = document.getElementById("cartEmpty");
    var totals = document.getElementById("cartTotals");
    var progress = document.getElementById("cartProgress");
    wrap.innerHTML = cart.items.map(function (i) {
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/, "_240x240$1$2") : "";
      // While a change is in flight the server still reports the old quantity.
      // Show what the shopper has asked for, not what the cart last said.
      var shown = qtyPending[i.key] != null ? qtyPending[i.key] : i.quantity;
      var esc = function (t) { var d = document.createElement("div"); d.textContent = t; return d.innerHTML; };
      var name = esc(i.product_title);
      return '<div class="cart-item">' +
        '<div class="cart-item__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" decoding="async">' : "") + '</div>' +
        '<div class="cart-item__info">' +
        '<a class="cart-item__title" href="' + i.url + '">' + name + '</a>' +
        '<button type="button" class="cart-item__remove" data-key="' + i.key + '" data-remove="1" aria-label="' +
          (I.remove || "Remove") + ' ' + name + '"><svg aria-hidden="true"><use href="#i-x"/></svg></button>' +
        '<span class="cart-item__price">' + fmt(i.final_line_price) + '</span>' +
        '<span class="cart-item__qty">' +
          // Disabled at one rather than silently deleting the line. There is a
          // remove button an inch away; a shopper tapping "−" is adjusting a
          // quantity, not asking to lose the item.
          '<button type="button" data-key="' + i.key + '" data-delta="-1"' + (shown <= 1 ? ' disabled' : '') +
            ' aria-label="' + (I.decrease || "Decrease quantity") + '">&minus;</button>' +
          '<span class="cart-item__qtynum" aria-live="polite">' + shown + '</span>' +
          '<button type="button" data-key="' + i.key + '" data-delta="1" aria-label="' + (I.increase || "Increase quantity") + '">+</button>' +
        '</span>' +
        '</div></div>';
    }).join("");
    if (empty) empty.hidden = cart.items.length > 0;
    if (totals) totals.style.display = cart.items.length ? "flex" : "none";
    var sub = document.getElementById("cartSubtotal");
    if (sub) sub.textContent = fmt(cart.total_price);
    // The drawer footer holds the checkout button and is marked hidden in the
    // layout until the cart has something in it; nothing revealed it, so for a
    // day the drawer had no way to check out. Delivery is deliberately not
    // priced here: the shipping cost appears only at checkout.
    var foot = document.getElementById("cartFooter");
    if (foot) foot.hidden = !cart.items.length;
    if (progress) {
      progress.style.display = cart.items.length ? "" : "none";
      var label = document.getElementById("cartProgressLabel");
      var fill = document.getElementById("cartProgressFill");
      var remaining = FREE_SHIP - cart.total_price;
      if (label) label.innerHTML = remaining > 0
        ? (I.awayFree1 || "You're") + " <b>" + fmt(remaining) + "</b> " + (I.awayFree2 || "away from free delivery")
        : "<b>" + (I.unlockedFree || "You've unlocked free delivery!") + "</b>";
      if (fill) fill.style.width = Math.min(100, (cart.total_price / FREE_SHIP) * 100) + "%";
    }
    wrap.querySelectorAll("[data-key]").forEach(function (b) {
      b.addEventListener("click", function () {
        var key = b.dataset.key;
        if (b.dataset.remove) return setQty(key, 0);
        // Compute from what the shopper is looking at, not from a number baked
        // into the DOM when this row was rendered. The old build put the target
        // quantity in data-q, so every click that landed before the previous
        // response re-rendered the row re-sent the SAME target: five quick taps
        // on "+" moved the quantity from 1 to 2 and then appeared to do nothing.
        var base = qtyPending[key] != null ? qtyPending[key] : parseInt(
          (b.parentNode.querySelector(".cart-item__qtynum") || {}).textContent || "1", 10);
        setQty(key, Math.max(0, base + parseInt(b.dataset.delta, 10)));
      });
    });
  }
  // One request at a time, in the order the shopper clicked. Parallel writes to
  // cart/change.js race and the last response to land wins, which is not
  // necessarily the last button pressed.
  var qtyPending = {};
  var cartChain = Promise.resolve();
  // Checkout waits while a quantity change is in flight, so nobody pays for a
  // cart the server has not confirmed. It is a counter, released on failure as
  // well as success, so it can never leave the button disabled.
  var inflight = 0;
  function checkoutBusy(on) {
    Array.prototype.forEach.call(document.querySelectorAll("[data-cart-checkout]"), function (a) {
      if (on) a.setAttribute("aria-disabled", "true"); else a.removeAttribute("aria-disabled");
    });
  }
  function settle() { inflight = Math.max(0, inflight - 1); if (!inflight) checkoutBusy(false); }
  function setCartError(on) {
    var e = document.getElementById("cartError");
    if (!e) return;
    var RI = (window.KIDDIL && window.KIDDIL.recoveryI18n) || {};
    if (on) e.textContent = RI.cartError || "We couldn't update your cart. Check your connection and try again.";
    e.hidden = !on;
  }
  function setQty(key, target) {
    qtyPending[key] = target;
    inflight++;
    checkoutBusy(true);
    setCartError(false);
    var wrap = document.getElementById("cartItems");
    if (wrap) {
      var row = wrap.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
      var num = row && row.parentNode.querySelector(".cart-item__qtynum");
      if (num && target > 0) num.textContent = target;   // optimistic
    }
    cartChain = cartChain.then(function () {
      return fetch(cartRoot + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: target })
      }).then(function (r) {
        if (!r.ok) throw new Error("cart change failed: " + r.status);
        return r.json();
      }).then(function (cart) {
        if (qtyPending[key] === target) delete qtyPending[key];
        renderCartData(cart);
      }).catch(function () {
        // Never leave an optimistic number the cart does not agree with.
        delete qtyPending[key];
        setCartError(true);
        return refreshCart();
      });
    // Settling on rejection too keeps the queue alive: a single failed refresh
    // used to leave cartChain rejected, and every later +/- was silently skipped.
    }).then(settle, settle);
    return cartChain;
  }
  function refreshCart() {
    return fetch(cartRoot + "cart.js").then(function (r) { return r.json(); }).then(renderCartData);
  }
  // qty defaults to 1 so every existing caller (product cards, "Parents Also
  // Liked") keeps working untouched; only the product page passes a number.
  function addToCart(variantId, qty, then) {
    var n = parseInt(qty, 10);
    if (!isFinite(n) || n < 1) n = 1;
    return fetch(cartRoot + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: +variantId, quantity: n })
    }).then(function (r) {
      if (!r.ok) throw new Error("add failed");
      return refreshCart();
    }).then(function () {
      if (then === "checkout") { window.location.href = cartRoot + "checkout"; return; }
      openDrawer(cartDrawer);
    }).catch(function () { window.location.href = cartRoot + "cart"; });
  }
  function pdpQtyValue() {
    var el = document.getElementById("pdpQty");
    return el ? el.value : 1;
  }
  var cartBtn = document.querySelector("[data-cart-open]");
  if (cartBtn) cartBtn.addEventListener("click", function (e) {
    e.preventDefault();
    refreshCart();
    openDrawer(cartDrawer);
  });
  Array.prototype.slice.call(document.querySelectorAll("[data-add]")).forEach(function (b) {
    b.addEventListener("click", function (e) {
      e.preventDefault();
      // Only the product page's button sits next to a quantity stepper; a card
      // in a grid always means one.
      addToCart(b.dataset.id, b.closest("#pdpAtc") ? pdpQtyValue() : 1);
    });
  });
  var buyNow = document.querySelector("[data-buynow]");
  if (buyNow) buyNow.addEventListener("click", function (e) {
    e.preventDefault();
    buyNow.disabled = true;
    addToCart(buyNow.dataset.id, pdpQtyValue(), "checkout");
  });
  updateBadge((window.KIDDIL && window.KIDDIL.cartCount) || 0);

  /* ---------- Predictive search ---------- */
  var suggestWrap = document.getElementById("suggestResults");
  var suggestTimer = null;
  if (searchInput && suggestWrap) {
    searchInput.addEventListener("input", function () {
      clearTimeout(suggestTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) return;
      suggestTimer = setTimeout(function () {
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=4")
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var prods = (((d.resources || {}).results || {}).products) || [];
            if (!prods.length) return;
            suggestWrap.innerHTML = prods.map(function (p) {
              return '<a class="search-suggest__row" href="' + p.url + '">' +
                (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="">' : "") +
                '<span class="n">' + p.title + '</span>' +
                '<span class="p">' + money(Math.round(parseFloat(p.price))) + '</span></a>';
            }).join("");
            var h = document.querySelector(".search-suggest h4");
            if (h) h.textContent = I.productsCaps || "PRODUCTS";
          });
      }, 250);
    });
  }

  /* ---------- Filter & Sort apply ---------- */
  var applyBtn = document.getElementById("filterApply");
  var clearBtn = document.getElementById("filterClear");
  var filterRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    (/^ar(?:-|$)/i.test(document.documentElement.lang) && /^\/ar(?:\/|$)/.test(location.pathname) ? "/ar/" : "/");
  filterRoot = filterRoot.replace(/\/?$/, "/");
  function collectionBase() {
    var path = location.pathname;
    if (filterRoot !== "/" && path.indexOf(filterRoot) === 0) path = "/" + path.slice(filterRoot.length);
    var m = path.match(/^(\/collections\/[^\/]+)/);
    var base = m ? m[1] : ((window.KIDDIL && window.KIDDIL.collectionUrl) || "/collections/all");
    return filterRoot !== "/" && base.indexOf(filterRoot) === 0 ? base : filterRoot + base.replace(/^\//, "");
  }
  if (applyBtn) applyBtn.addEventListener("click", function () {
    // The drawer now offers collections, not tags: /collections/<handle> rather
    // than /collections/<base>/<tag>. Every tag it used to send was absent from
    // the catalogue, so each filter landed on an empty page.
    var col = document.querySelector('#filterDrawer input[name="fcol"]:checked');
    var sort = document.querySelector('#filterDrawer input[name="sort"]:checked');
    var url = col ? filterRoot + "collections/" + col.value : collectionBase();
    if (sort && sort.value) url += "?sort_by=" + sort.value;
    window.location.href = url;
  });
  if (clearBtn) clearBtn.addEventListener("click", function () {
    window.location.href = collectionBase();
  });

  /* ---------- PDP form intercept + share ---------- */
  var pdpForm = document.getElementById("pdpForm");
  if (pdpForm) pdpForm.addEventListener("submit", function (e) {
    // e.submitter tells us WHICH button submitted. Without it, pressing Buy it
    // now ran the add-to-cart branch and the shopper never reached checkout.
    var sub = e.submitter || pdpForm.querySelector("[data-add]");
    if (!sub) return;
    e.preventDefault();
    if (sub.hasAttribute("data-buynow")) addToCart(sub.dataset.id, pdpQtyValue(), "checkout");
    else addToCart(sub.dataset.id, pdpQtyValue());
  });
  var shareBtn = document.querySelector("[data-share]");
  if (shareBtn) shareBtn.addEventListener("click", function () {
    if (navigator.share) navigator.share({ title: document.title, url: location.href });
    else if (navigator.clipboard) navigator.clipboard.writeText(location.href);
  });

  /* ---------- Reveal on scroll ---------- */
  var revealEls = Array.prototype.slice.call(document.querySelectorAll(".reveal"));
  if (revealEls.length && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("in"); });
  }

  /* ---------- PDP: advanced gallery ---------- */
  var media = document.getElementById("pdpMedia");
  var mainImg = document.getElementById("pdpMainImg");
  var thumbs = Array.prototype.slice.call(document.querySelectorAll(".pdp__thumb"));
  var gImages = thumbs.length
    ? thumbs.map(function (t) { return { src: t.dataset.src, large: t.dataset.large, alt: t.dataset.alt || "" }; })
    : (mainImg ? [{ src: mainImg.src, large: mainImg.dataset.large || mainImg.src, alt: mainImg.alt }] : []);
  var gIndex = 0;
  var counter = document.getElementById("pdpCounter");
  var lb = document.getElementById("pdpLightbox");
  var lbImg = document.getElementById("lbImg");
  var lbCounter = document.getElementById("lbCounter");

  function preload(i) {
    var im = gImages[(i + gImages.length) % gImages.length];
    if (im) { var pi = new Image(); pi.src = im.src; }
  }
  function goTo2(i) {
    if (!gImages.length || !mainImg) return;
    gIndex = (i + gImages.length) % gImages.length;
    var im = gImages[gIndex];
    mainImg.src = im.src;
    mainImg.alt = im.alt;
    thumbs.forEach(function (t, k) { t.classList.toggle("is-active", k === gIndex); });
    var at = thumbs[gIndex];
    if (at && at.scrollIntoView) at.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
    if (counter) counter.textContent = (gIndex + 1) + " / " + gImages.length;
    if (lb && !lb.hidden) { lbImg.src = im.large; lbImg.alt = im.alt; lbCounter.textContent = (gIndex + 1) + " / " + gImages.length; }
    preload(gIndex + 1); preload(gIndex - 1);
  }
  thumbs.forEach(function (t, k) { t.addEventListener("click", function () { goTo2(k); }); });
  var prevB = document.getElementById("pdpPrev"), nextB = document.getElementById("pdpNext");
  if (prevB) prevB.addEventListener("click", function (e) { e.stopPropagation(); goTo2(gIndex - 1); });
  if (nextB) nextB.addEventListener("click", function (e) { e.stopPropagation(); goTo2(gIndex + 1); });

  /* swipe on main media */
  if (media) {
    var gsx = null;
    media.addEventListener("touchstart", function (e) { gsx = e.touches[0].clientX; }, { passive: true });
    media.addEventListener("touchend", function (e) {
      if (gsx === null) return;
      var dx = e.changedTouches[0].clientX - gsx;
      if (Math.abs(dx) > 40) goTo2(gIndex + (dx < 0 ? 1 : -1));
      gsx = null;
    }, { passive: true });
  }

  /* lightbox */
  function openLb() {
    if (!lb || !gImages.length) return;
    lb.hidden = false;
    document.body.style.overflow = "hidden";
    lbImg.src = gImages[gIndex].large;
    lbImg.alt = gImages[gIndex].alt;
    lbCounter.textContent = (gIndex + 1) + " / " + gImages.length;
    var multi = gImages.length > 1;
    document.getElementById("lbPrev").style.display = multi ? "" : "none";
    document.getElementById("lbNext").style.display = multi ? "" : "none";
    lbCounter.style.display = multi ? "" : "none";
  }
  function closeLb() {
    if (!lb) return;
    lb.hidden = true;
    document.body.style.overflow = "";
  }
  if (media) media.addEventListener("click", function (e) {
    if (e.target.closest(".pdp__nav")) return;
    openLb();
  });
  var zoomBtn = document.getElementById("pdpZoomBtn");
  if (zoomBtn) zoomBtn.addEventListener("click", function (e) { e.stopPropagation(); openLb(); });
  if (lb) {
    lb.addEventListener("click", function (e) {
      if (e.target === lb) closeLb();
    });
    document.getElementById("lbClose").addEventListener("click", closeLb);
    document.getElementById("lbPrev").addEventListener("click", function () { goTo2(gIndex - 1); });
    document.getElementById("lbNext").addEventListener("click", function () { goTo2(gIndex + 1); });
    var lsx = null;
    lb.addEventListener("touchstart", function (e) { lsx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener("touchend", function (e) {
      if (lsx === null) return;
      var dx = e.changedTouches[0].clientX - lsx;
      if (Math.abs(dx) > 40) goTo2(gIndex + (dx < 0 ? 1 : -1));
      lsx = null;
    }, { passive: true });
  }
  document.addEventListener("keydown", function (e) {
    if (e.target && /INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
    if (lb && !lb.hidden) {
      if (e.key === "Escape") closeLb();
      if (e.key === "ArrowLeft") goTo2(gIndex - 1);
      if (e.key === "ArrowRight") goTo2(gIndex + 1);
    } else if (mainImg && gImages.length > 1 && document.activeElement === media) {
      if (e.key === "ArrowLeft") goTo2(gIndex - 1);
      if (e.key === "ArrowRight") goTo2(gIndex + 1);
    }
  });
  if (/lightbox=1/.test(location.search)) openLb();
  if (gImages.length) preload(1);

  Array.prototype.slice.call(document.querySelectorAll(".pdp__swatch")).forEach(function (s) {
    s.addEventListener("click", function () {
      if (s.dataset.href) { location.href = s.dataset.href; return; }
      document.querySelectorAll(".pdp__swatch").forEach(function (x) { x.classList.remove("is-active"); });
      s.classList.add("is-active");
    });
  });
  var stickyBar = document.getElementById("stickyAtc");
  var atcAnchor = document.getElementById("pdpAtc");
  if (stickyBar && atcAnchor && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle("is-visible", !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(atcAnchor);
  }

  /* ---------- Newsletter: validation + phone normalization ---------- */
  var email = document.getElementById("nlEmail");
  var submit = document.getElementById("nlSubmit");
  var nlPhone = document.getElementById("nlPhone");
  var nlTags = document.getElementById("nlTags");
  if (email && submit) {
    email.addEventListener("input", function () {
      var ok = /.+@.+\..+/.test(email.value);
      submit.disabled = !ok;
      submit.classList.toggle("btn--disabled", !ok);
    });
    var nlForm = email.closest("form");
    var nlStatus = document.getElementById("nlStatus");
    function nlShow(ok, msg) {
      if (!nlStatus) return;
      nlStatus.hidden = false;
      nlStatus.className = "newsletter__status newsletter__status--" + (ok ? "ok" : "err");
      nlStatus.innerHTML = '<svg><use href="#i-' + (ok ? "check" : "x") + '"/></svg>' + msg;
    }
    function nlNormalizePhone(v) {
      var digits = (v || "").replace(/[^\d+]/g, "");
      if (/^01\d{9}$/.test(digits)) return "+20" + digits.slice(1);
      if (/^1\d{9}$/.test(digits)) return "+20" + digits;
      if (/^20\d{10}$/.test(digits)) return "+" + digits;
      if (/^\+\d{8,15}$/.test(digits)) return digits;
      return null;
    }
    function nlCreate(input) {
      return fetch("https://" + (window.KIDDIL && KIDDIL.sfShop || location.host) + "/api/2025-01/graphql.json", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": (window.KIDDIL && KIDDIL.sfToken) || "" },
        body: JSON.stringify({
          query: "mutation($input: CustomerCreateInput!) { customerCreate(input: $input) { customer { id } customerUserErrors { field message code } } }",
          variables: { input: input }
        })
      }).then(function (r) { return r.json(); });
    }
    if (nlForm) nlForm.addEventListener("submit", function (ev) {
      ev.preventDefault();
      var phoneRaw = nlPhone ? nlPhone.value.trim() : "";
      var phone = phoneRaw ? nlNormalizePhone(phoneRaw) : null;
      if (phoneRaw && !phone) { nlShow(false, I.nlBadPhone || "That phone number doesn't look right — try 01X XXXX XXXX."); return; }
      submit.disabled = true;
      submit.textContent = I.nlSubscribing || "Subscribing…";
      var pw = "Kd!" + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2).toUpperCase() + "9";
      var input = { email: email.value.trim(), acceptsMarketing: true, password: pw };
      if (phone) input.phone = phone;
      nlCreate(input).then(function (d) {
        var res = d && d.data && d.data.customerCreate;
        var errs = (res && res.customerUserErrors) || [];
        function done(ok, msg) {
          submit.disabled = false;
          submit.textContent = I.nlSubscribe || "Subscribe Now";
          nlShow(ok, msg);
          if (ok) { email.value = ""; if (nlPhone) nlPhone.value = ""; submit.disabled = true; submit.classList.add("btn--disabled"); }
        }
        if (res && res.customer) { done(true, I.nlOk || "You're in!"); return; }
        var codes = errs.map(function (e) { return e.code; });
        if (codes.indexOf("TAKEN") > -1) { done(true, I.nlAlready || "You're already on the list!"); return; }
        if (phone && errs.some(function (e) { return (e.field || []).indexOf("phone") > -1; })) {
          delete input.phone;
          nlCreate(input).then(function (d2) {
            var r2 = d2 && d2.data && d2.data.customerCreate;
            if (r2 && r2.customer) done(true, I.nlOkNoPhone || "You're in!");
            else if (((r2 && r2.customerUserErrors) || []).some(function (e) { return e.code === "TAKEN"; })) done(true, I.nlAlready || "You're already on the list!");
            else done(false, I.nlErr || "Something went wrong — please try again.");
          }).catch(function () { done(false, I.nlErr || "Something went wrong — please try again."); });
          return;
        }
        if (errs.length) { done(false, errs[0].message); return; }
        done(false, I.nlErr || "Something went wrong — please try again.");
      }).catch(function () {
        submit.disabled = false;
        submit.textContent = I.nlSubscribe || "Subscribe Now";
        nlShow(false, I.nlNet || "Couldn't reach the server — try again.");
      });
    });
  }

  /* ---------- demo states for screenshots/QA (?demo=menu|search|cart|filter|qv) ---------- */
  var demo = (location.search.match(/demo=(\w+)/) || [])[1];
  if (demo === "menu" && menuItems[0]) {
    menuItems[0].classList.add("is-open");
    header.classList.add("has-open-menu");
  } else if (demo === "search") {
    openSearch();
  } else if (demo === "cart") {
    refreshCart();
    openDrawer(cartDrawer);
  } else if (demo === "filter") {
    openDrawer(filterDrawer);
  } else if (demo === "qv") {
    var qvBtn = document.querySelector("[data-qv]");
    if (qvBtn) qvBtn.click();
  } else if (demo === "mmenu") {
    if (mdrawer) {
      openDrawer(mdrawer);
      var g1 = mdrawer.querySelector(".mobile-drawer__group");
      if (g1) g1.setAttribute("open", "");
    }
  }
})();

/* Shopify theme editor: reload page JS when sections are re-rendered */
if (window.Shopify && Shopify.designMode) {
  document.addEventListener("shopify:section:load", function () { window.location.reload(); });
}


/* ---------- quick view ----------------------------------------------------
   Every product card renders a [data-qv] button, but nothing ever listened for
   a click on one: the only mention of data-qv was inside the `?demo=qv` QA
   branch, which simulates a click on a handler that does not exist. So the eye
   icon was decorative on every card in the shop.

   Listening on `document` rather than binding each button matters here — cards
   are rendered by several sections and also appear inside this very modal, so
   anything bound at load would miss the ones added later. */
(function () {
  var modal = document.getElementById("quickView");
  if (!modal) return;

  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    (/^ar(?:-|$)/i.test(document.documentElement.lang) && /^\/ar(?:\/|$)/.test(location.pathname) ? "/ar/" : "/");
  cartRoot = cartRoot.replace(/\/?$/, "/");

  var els = {
    img: document.getElementById("qvImage"),
    title: document.getElementById("qvTitle"),
    price: document.getElementById("qvPrice"),
    was: document.getElementById("qvWas"),
    stock: document.getElementById("qvStock"),
    variants: document.getElementById("qvVariants"),
    desc: document.getElementById("qvDesc"),
    add: document.getElementById("qvAdd"),
    full: document.getElementById("qvFull"),
    msg: document.getElementById("qvMsg")
  };
  var scrim = document.getElementById("scrim");
  var lastFocus = null;
  var current = null;

  function money(cents) {
    // Shopify gives minor units. Fall back to a plain format if the shop's
    // money format string is not exposed on this page.
    var v = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var pat = (window.KIDDIL && window.KIDDIL.i18n && window.KIDDIL.i18n.money) || "EGP __AMT__";
    return pat.replace("__AMT__", v);
  }

  function close() {
    modal.classList.remove("is-open");
    modal.hidden = true;
    if (scrim) scrim.classList.remove("is-open");
    document.body.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function open(handle, trigger) {
    lastFocus = trigger || null;
    els.msg.textContent = "";
    els.title.textContent = "Loading…";
    els.price.textContent = "";
    els.was.hidden = true;
    els.stock.textContent = "";
    els.desc.textContent = "";
    els.variants.hidden = true;
    els.img.removeAttribute("src");
    modal.hidden = false;
    modal.classList.add("is-open");
    document.body.style.overflow = "hidden";

    var productRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (/^ar(?:-|$)/i.test(document.documentElement.lang) && /^\/ar(?:\/|$)/.test(location.pathname) ? "/ar/" : "/");
    productRoot = productRoot.replace(/\/?$/, "/");
    fetch(productRoot + "products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (p) { render(p); })
      .catch(function () {
        // Never leave the panel on "Loading…": send them to the real page instead.
        els.title.textContent = "Sorry — we couldn't load this here.";
        els.msg.textContent = "Open the full product page instead.";
        els.full.href = "/products/" + handle;
      });
  }

  function render(p) {
    current = p;
    els.title.textContent = p.title;
    els.full.href = p.url;
    if (p.featured_image) {
      els.img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, "_600x$1$2");
      els.img.alt = p.title;
    }
    var text = (p.description || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    els.desc.textContent = text.slice(0, 320) + (text.length > 320 ? "…" : "");

    if (p.variants.length > 1) {
      els.variants.innerHTML = p.variants.map(function (v) {
        return '<option value="' + v.id + '"' + (v.available ? "" : " disabled") + ">" +
               v.title + (v.available ? "" : " — sold out") + "</option>";
      }).join("");
      els.variants.hidden = false;
      var firstAvailable = p.variants.filter(function (v) { return v.available; })[0];
      if (firstAvailable) els.variants.value = firstAvailable.id;
    } else {
      els.variants.hidden = true;
    }
    paintVariant(selectedVariant());
  }

  function selectedVariant() {
    if (!current) return null;
    if (!els.variants.hidden && els.variants.value) {
      var id = parseInt(els.variants.value, 10);
      return current.variants.filter(function (v) { return v.id === id; })[0] || current.variants[0];
    }
    return current.variants.filter(function (v) { return v.available; })[0] || current.variants[0];
  }

  function paintVariant(v) {
    if (!v) return;
    els.price.textContent = money(v.price);
    if (v.compare_at_price && v.compare_at_price > v.price) {
      els.was.textContent = money(v.compare_at_price);
      els.was.hidden = false;
    } else { els.was.hidden = true; }
    els.stock.textContent = v.available ? "In stock" : "Out of stock";
    els.stock.className = "qv__stock " + (v.available ? "qv__stock--in" : "qv__stock--out");
    els.add.disabled = !v.available;
    els.add.textContent = v.available ? (els.add.dataset.label || els.add.textContent) : "Sold out";
  }

  els.variants.addEventListener("change", function () { paintVariant(selectedVariant()); });

  els.add.addEventListener("click", function () {
    var v = selectedVariant();
    if (!v || !v.available) return;
    els.add.disabled = true;
    els.msg.textContent = "";
    fetch(cartRoot + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function () {
        close();
        // Re-use the header's own cart button so the drawer opens and refreshes
        // through the theme's existing code path rather than a second one.
        var cartBtn = document.querySelector("[data-cart-open]");
        if (cartBtn) cartBtn.click(); else window.location.href = cartRoot + "cart";
      })
      .catch(function () {
        els.add.disabled = false;
        els.msg.textContent = "Couldn't add that to the basket — please try the product page.";
      });
  });

  document.addEventListener("click", function (e) {
    var t = e.target;
    var btn = t.closest && t.closest("[data-qv]");
    if (btn) { e.preventDefault(); open(btn.getAttribute("data-qv"), btn); return; }
    if (t.closest && t.closest("[data-qv-close]")) { e.preventDefault(); close(); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("is-open")) close();
  });
})();

/* Hover photo, loaded on demand.
   The reveal is CSS inside @media (hover: hover), so a touch device can never
   display this image — but it used to download it anyway on scroll. The card
   ships it as data-src; this promotes it the first time a pointer actually
   enters the tile, which cannot happen on a touch-only device. */
(function () {
  var swap = function (tile) {
    var img = tile.querySelector('.product-tile__img--alt[data-src]');
    if (!img) return;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  };
  document.addEventListener('pointerenter', function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || typeof t.closest !== 'function') return;
    var tile = t.closest('.product-tile--has-alt');
    if (tile) swap(tile);
  }, true);
  // Keyboard users never fire pointerenter; focus inside the tile counts too.
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var tile = t.closest('.product-tile--has-alt');
    if (tile) swap(tile);
  });
})();

/* Quantity stepper — product page and cart page.
   The input is the source of truth so a typed value and the buttons cannot
   disagree, and the markup posts natively: `quantity` on the product form,
   `updates[]` on the cart form. Works with JavaScript off; the buttons are the
   enhancement. */
(function () {
  function wire(box) {
    var input = box.querySelector(".qty-stepper__input");
    var minus = box.querySelector('[data-qty-step="-1"]');
    if (!input) return;
    var floor = parseInt(input.getAttribute("min"), 10);
    if (!isFinite(floor)) floor = 1;
    function clamp() {
      var n = parseInt(input.value, 10);
      if (!isFinite(n) || n < floor) n = floor;
      if (n > 999) n = 999;
      input.value = n;
      // On the cart page min is 0 (zero removes the line), so the guard is
      // "one above the floor", not a hardcoded 1.
      if (minus) minus.disabled = n <= Math.max(floor, 1);
      return n;
    }
    box.addEventListener("click", function (e) {
      var b = e.target.closest("[data-qty-step]");
      if (!b || b.disabled) return;
      input.value = clamp() + parseInt(b.dataset.qtyStep, 10);
      clamp();
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    input.addEventListener("input", clamp);
    input.addEventListener("blur", clamp);
    clamp();
  }
  Array.prototype.slice.call(document.querySelectorAll(".qty-stepper")).forEach(wire);
})();
